import React from 'react';

const Membership = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M13.3333 14.7267L14.9667 15.72L14.5333 13.8467L16 12.5933L14.0733 12.4267L13.3333 10.6667L12.58 12.4267L10.6667 12.5933L12.12 13.8467L11.6667 15.72L13.3333 14.7267ZM9.38667 14H1.33333C0.983618 13.9877 0.651562 13.8433 0.404123 13.5959C0.156685 13.3484 0.0122703 13.0164 0 12.6667L0 3.33333C0.0266667 2.60667 0.606667 2.02667 1.33333 2H14.6667C15.3933 2.02667 15.9733 2.60667 16 3.33333V10.3533C15.6133 10 15.1667 9.74 14.6667 9.56V3.33333H1.33333V12.6667H9.38667C9.35333 12.8867 9.33333 13.1067 9.33333 13.3333C9.33333 13.56 9.35333 13.7867 9.38667 14ZM9.33333 11.3333H2.66667V10.5C2.66667 9.39333 4.89333 8.83333 6 8.83333C7.10667 8.83333 9.33333 9.39333 9.33333 10.5V11.3333ZM9.33333 7.33333H12V8H9.33333V7.33333ZM6 4.66667C5.08667 4.66667 4.33333 5.42 4.33333 6.33333C4.33333 7.24667 5.08667 8 6 8C6.91333 8 7.66667 7.24667 7.66667 6.33333C7.66667 5.42 6.91333 4.66667 6 4.66667ZM9.33333 6H13.3333V6.66667H9.33333V6ZM9.33333 4.66667H13.3333V5.33333H9.33333V4.66667Z"
        fill="white"
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Membership;
